<template>
    <likes :likedContentUuid="articleUuid" category="article" />
    <comments-counter
      :article-uuid="articleUuid"
      use-bold-font
      :article-url="articleUrl"
      :showSmall=true  />
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import Likes from './components/likes/Likes.vue'
import CommentsCounter from './components/comments/CommentsCounter.vue'


export default defineComponent({
  components: {
    Likes,
    CommentsCounter
  },
  name: 'WidgetCommentsCounter',
  props: {
    articleUuid: String,
    useBoldFont: Boolean,
    articleUrl: {
      type: String,
      required: false
    }
  }
});
</script>

